module.exports = __webpack_public_path__ + "img/temp-logo-tiny.ba8d771c.png";